// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const ExampleCodeSample = {
    language: (value) => {
        return Object.assign(Object.assign({}, value), { type: "language", _visit: function (visitor) {
                return FernIr.ExampleCodeSample._visit(this, visitor);
            } });
    },
    sdk: (value) => {
        return Object.assign(Object.assign({}, value), { type: "sdk", _visit: function (visitor) {
                return FernIr.ExampleCodeSample._visit(this, visitor);
            } });
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "language":
                return visitor.language(value);
            case "sdk":
                return visitor.sdk(value);
            default:
                return visitor._other(value);
        }
    },
};
